import { FC } from 'react';
import { dineroFormat, dineroSubtract, dineroSubtractAmount } from 'src/common/utils/dataFormat';
import { IOrderFetch } from 'src/models/IOrder';
import './styles.scss';

interface IProps {
  order: IOrderFetch;
}

const TotalPrice: FC<IProps> = ({ order }) => {
  const { price, currency, partial_paid } = order;

  return (
    <div className='total-price'>
      <div className='total-price__item'>
        <div className='total-price__title'>Total incl Fees:</div>
        <div className='total-price__price paid'>{dineroFormat(price, currency)}</div>
      </div>
      <div className='total-price__item'>
        <div className='total-price__title'>Paid:</div>
        <div className='total-price__price partial'>{dineroFormat(partial_paid, currency)}</div>
      </div>
      {dineroSubtractAmount(price, partial_paid!, currency) ? (
        <div className='total-price__item'>
          <div className='total-price__title'>
            Due:
            <div className='total-price__subtitle'>autom. charged 2 days before trip</div>
          </div>
          <div className='total-price__price full'>
            {dineroSubtract(price, partial_paid, currency)}
          </div>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};

export default TotalPrice;
